export const PAGE_SIZE = 20;
export const TRUNCATE_TEXT_LENGHT = 20;
export const TRUNCATE_TEXT_LENGHT_40 = 40;
export const LIST_ACTION_IGNORE_ACTIVE_MENU = ['add', 'edit', 'detail'];

export const fallbackImgae =
  'data:image/png;base64,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';

export enum PAGINATE_DEFAULT {
  PAGE = 1,
  LIMIT = 10,
  LIMIT_50 = 50,
  LIMIT_CHART = 5,
}

export enum STATUS_DEFAULT {
  SUCCESS = 'SUCCESS',
}

export enum TYPE_ACCOUNT {
  ADMIN = 'ADMIN',
  TEACHER = 'TEACHER',
  PARENT = 'PARENT',
}

export enum EModalSize {
  default = 500,
  medium = 626,
  width800 = 800,
  width700 = 700,
  width860 = 860,
  width900 = 900,
  width1170 = 1170,
  half = '50vw',
  large = '80vw',
}

export enum ETextEditor {
  MIN_CHARACTERS = 2,
  MEDIUM_CHARACTERS = 500,
  MAX_CHARACTERS = 50000,
  MAX_TERMS,
}
export enum ETextInput {
  MIN_CHARACTERS = 2,
  MAX_CHARACTERS = 255,
}

// loại địa điểm quen thuộc
export enum ETrustAddressType {
  HOME = 'HOME', // nhà
  COMPANY = 'COMPANY', // công ty
  OTHER = 'OTHER', // khác
}

export enum ECommontStatus {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
}
export enum ECommontStatusText {
  INACTIVE = 'Ẩn',
  ACTIVE = 'Hiện',
}

// loại dịch vụ
export enum ESericeType {
  CompoundCar = 1, // Xe ghép
  Ship = 2, // Gửi đồ
  Airport = 3, // Sân bay
  Truck = 4, // Xe tải
  Taxi = 5, //Taxi
  All = 6,
}
export enum ESericeTypeText {
  ALL = 'ALL',
  KHACH_SI = 'KHACH_SI',
  KHACH_LE = 'KHACH_LE',
  CTV = 'CTV',
}
export enum EArea {
  North = 1, //miền bắc
  Central = 2, // miền trong
  Southern = 3, //miền nam
}
export interface IServiceOption {
  value: ESericeType;
  label: string;
}
export const ESericeTypeOption: IServiceOption[] = [
  {
    value: ESericeType.CompoundCar,
    label: 'Xe ghép',
  },
  {
    value: ESericeType.Ship,
    label: 'Gửi đồ',
  },
  {
    value: ESericeType.Airport,
    label: 'Sân bay',
  },
  {
    value: ESericeType.Taxi,
    label: 'Xe taxi',
  },
];
export interface ISelect {
  value: any;
  label: string;
  disabled?: boolean;
}

// loại giảm giá theo phần trăm hay giá tiền
export enum EDiscountType {
  PRICE = 'PRICE',
  PERCENT = 'PERCENT',
}
export enum ActivityAreaCond {
  AND = 'and',
  OR = 'or',
}
export enum ActivityAreaCondText {
  AND = 'Và',
  OR = 'Hoặc',
}

export enum EObjectNotifyType {
  CUSTOMER = 1, //khách hàng
  CTV = 'CTV',
  BULK = 'BULK',
  RETAIL = 'RETAIL',
  ALL = 4, //tất cả
}
export enum EObjectNotifyTypeText {
  CUSTOMER = 'CUSTOMER', //khách hàng
  CTV = 'CTV',
  BULK = 'BULK',
  RETAIL = 'RETAIL',
  ALL = 'ALL', //tất cả
}
export enum ENotiLoopType {
  NoLoop = 0, // không lặp lại
  Daily = 1, // lặp hàng ngày
  ByWeek = 2, // lặp theo tuần
  ByMonth = 3, // lặp theo tháng
}
export interface IOption {
  label: string;
  value: number;
}

export enum ELogType {
  AdminLogin = 1, // admin đăng nhập
  CreateAccount = 2, // Tạo tài khoản
  ActivateAccount = 3, // kích hoạt tài khoản
  BlockAccount = 4, // khoá tài khoản
  // ChangeDriver = 5, // Thay đổi tài xế cho chuyến đi
  CreateSystemConfig = 6, // Tạo cấu hình
  UpdateSystemConfig = 7, // Sửa cấu hình
  CreateVoucher = 8, // Tạo voucher
  UpdateVoucher = 9, // Sửa voucher
  CreateNotify = 10, // Tạo thông báo
  UpdateNotify = 11, // Sửa thông báo
  CreateAdmin = 12, // Tạo tài khoản admin
  UpdateAdmin = 13, // Sửa tài khoản admin
  ChangePassAdmin = 14, // Đổi mật khẩu tài khoản admin
  ResetPassAdmin = 15, // Reset mật khẩu tài khoản admin
  // CreateProvince = 16, // Tạo tỉnh thành
  // UpdateProvince = 17, // Sửa tỉnh thành
  // RemoveProvince = 18, // Xoá tỉnh thành
  // CreateDistrict = 19, // Tạo quận huyện
  // UpdateDistrict = 20, // Sửa quận huyện
  // RemoveDistrict = 21, // Xoá quận huyện
  // CreateNews = 22, // Tạo tin tức
  // UpdateNews = 23, // Sửa tin tức
  // RemoveNews = 24, // Xoá tin tức
  // ChangeStatusNews = 25, // Bật tắt tin tức
  CreateBanner = 26, // Tạo banner
  UpdateBanner = 27, // Sửa banner
  RemoveBanner = 28, // Xoá banner
  CreateFAQ = 29, // Tạo FAQ
  UpdateFAQ = 30, // Sửa FAQ
  RemoveFAQ = 31, // Xoá FAQ
  CreateRulesAndRegulations = 32, // Tạo nội quy và quy chế ko
  UpdateRulesAndRegulations = 33, // Sửa nội quy và quy chế ko
  ConfirmComplain = 34, // Xác nhận giải quyết khiếu nại
  RemoveVoucher = 35, // Xoá voucher
  CreateInsTruction = 36, //Tạo hướng dẫn sử dụng
  UpdateInsTruction = 37, //Sửa hướng dẫn sử dụng
  CreateOrder = 38, //Tạo đơn hàng
  UpdateOrder = 39, //Sửa đơn hàng
  ConfirmOrder = 40, //Duyệt đơn hàng
  CreateDelivery = 41, //Tạo đơn giao hàng
  CancelDelivery = 42, //Huỷ đơn giao hàng
  ExportWarehouse = 43, //Xuất kho
  CancelOrder = 44, //Huỷ đơn hàng
  ConfirmPayOrder = 45, //Thanh toán đơn hàng
  CreateReturnProduct = 46, //Tạo đơn trả hàng
  CancelReturnProduct = 47, //Huỷ đơn trả hàng
  ConfirmReturnProduct = 48, //Xác nhận nhập trả hàng
  UpdateCustomer = 49, //Cập nhật khách hàng
  CreateReceiptCustomer = 50, //Tạo phiếu thu khách hàng
  CreateRank = 51, //Tạo rank
  UpdateRank = 52, //Sửa rank
  DeleteRank = 53, //Xoá rank
  DeleteAdmin = 54, //Xoá admin
  CreateGroupAdmin = 55, //Tạo nhóm admin
  UpdateGroupAdmin = 56, //Sửa nhóm admin
  DeleteGroupAdmin = 57, //Xoá nhóm admin
  CreateProduct = 58, //Tạo sản phẩm
  UpdateProduct = 59, //Sửa sản phẩm
  DeleteProduct = 60, //Xoá sản phẩm
  ChangeStatusProduct = 61, //Thay đổi trạng thái sản phẩm
  CreateProductCategory = 62, //Tạo danh mục sản phẩm
  UpdateProductCategory = 63, //Sửa danh mục sản phẩm
  DeleteProductCategory = 64, //Xoá danh mục sản phẩm
  ChangeStatusProductCategory = 65, //Thay đổi trạng thái danh mục sản phẩm
  CreateProductGroup = 66, //Tạo nhóm sản phẩm
  UpdateProductGroup = 67, //Sửa nhóm sản phẩm
  DeleteProductGroup = 68, //Xoá nhóm sản phẩm
  ChangeStatusProductGroup = 69, //Thay đổi trạng thái nhóm sản phẩm
  CreateWarehouse = 70, //Tạo kho
  UpdateWarehouse = 71, //Sửa kho
  DeleteWarehouse = 72, //Xoá kho
  CreateSupplier = 73, //Tạo ncc
  UpdateSupplier = 74, //Sửa ncc
  DeleteSupplier = 75, //Xoá ncc
  CreateReceiptSupplier = 76, //Tạo phiếu thu ncc
  CreatePaySlipSupplier = 77, //Tạo phiếu chi ncc
  CreatePurchaseOrder = 78, //Tạo đơn đặt
  UpdatePurchaseOrder = 79, //Sửa đơn đặt
  CancelPurchaseOrder = 80, //Huỷ đơn đặt
  CreateImport = 81, //Tạo đơn nhập
  UpdateImport = 82, //Sửa đơn nhập
  CancelImport = 83, //Huỷ đơn nhập
  ConfirmImport = 84, //Xác nhận nhập đơn nhập
  ConfirmPayImport = 85, //Xác nhận thanh toán
  CreateReturnSupplier = 86, //Tạo đơn trả ncc
  ConfirmPayReturnSupplier = 87, //Xác nhận thanh toán đơn trả ncc
  CreateTransfer = 88, //Tạo điều chuyển
  UpdateTransfer = 89, //Sửa điều chuyển
  CancelTransfer = 90, //Huỷ điều chuyển
  FinishTransfer = 91, //Hoàn thành điều chuyển
  ConfirmTransfer = 92, //Xác nhận điều chuyển
  CreateSale = 93, //Tạo sale
  UpdateSale = 94, //Sửa sale
  ChangeStatusSale = 95, //thay đổi trạng thái sale
  DeleteSale = 96, //Xoá sale
  CreateFlashSale = 97, //Tạo Flashsale
  UpdateFlashSale = 98, //Sửa Flashsale
  ChangeStatusFlashSale = 99, //thay đổi trạng thái Flashsale
  DeleteFlashSale = 100, //Xoá Flashsale
  CreateGift = 101, //Tạo Gift
  UpdateGift = 102, //Sửa Gift
  ChangeStatusGift = 103, //thay đổi trạng thái Gift
  DeleteGift = 104, //Xoá Gift
  CreateBuyALot = 105, //Tạo BuyALot
  UpdateBuyALot = 106, //Sửa BuyALot
  ChangeStatusBuyALot = 107, //thay đổi trạng thái BuyALot
  DeleteBuyALot = 108, //Xoá BuyALot
  ChangeStatusVoucher = 109, // Thay đổi trạng thái voucher
  DeleteNotify = 110, // Xoá thông báo
  ChangeStatusBanner = 111, // Thay đổi trạng thái banner
  CreateSplashScreen = 112, //Tạo SplashScreen
  UpdateSplashScreen = 113, //Sửa SplashScreen
  ChangeStatusSplashScreen = 114, //thay đổi trạng thái SplashScreen
  DeleteSplashScreen = 115, //Xoá SplashScreen
  DeleteInsTruction = 116, //Xoá hướng dẫn sử dụng
  ChangeStatusSystemConfig = 117, //Thay đổi trạng thái cấu hình
  DeleteSystemConfig = 118, //Xoá cấu hifnh
  CreatePaySlipType = 119, //Tạo loại phiếu chi
  UpdatePaySlipType = 120, //Sửa loại phiếu chi
  DeletePaySlipType = 121, //Xoá loại phiếu chi
  CreateReceiptType = 122, //Tạo loại phiếu thu
  UpdateReceiptType = 123, //Sửa loại phiếu thu
  DeleteReceiptType = 124, //Xoá loại phiếu thu
  CreatePaySlip = 125, //Tạo phiếu chi
  CreateReceipt = 126, //Tạo phiếu thu
  CancelPaySlip = 127, //Hủy phiếu chi
  CancelReceipt = 128, //Hủy phiếu thu
}
export interface IOptionLogListActivity {
  value: ELogType;
  label: string;
}

export const optionsLogListActivity: IOptionLogListActivity[] = [
  { value: ELogType.AdminLogin, label: 'Admin đăng nhập' },
  { value: ELogType.CreateAccount, label: 'Tạo tài khoản' },
  { value: ELogType.ActivateAccount, label: 'Kích hoạt tài khoản' },
  { value: ELogType.BlockAccount, label: 'Khoá tài khoản' },
  // { value: ELogType.ChangeDriver, label: 'Thay đổi tài xế cho chuyến đi' },
  { value: ELogType.CreateSystemConfig, label: 'Tạo cấu hình' },
  { value: ELogType.UpdateSystemConfig, label: 'Sửa cấu hình' },
  { value: ELogType.CreateVoucher, label: 'Tạo voucher' },
  { value: ELogType.UpdateVoucher, label: 'Sửa voucher' },
  { value: ELogType.CreateNotify, label: 'Tạo thông báo' },
  { value: ELogType.UpdateNotify, label: 'Sửa thông báo' },
  { value: ELogType.CreateAdmin, label: 'Tạo tài khoản admin' },
  { value: ELogType.UpdateAdmin, label: 'Sửa tài khoản admin' },
  { value: ELogType.ChangePassAdmin, label: 'Đổi mật khẩu tài khoản admin' },
  { value: ELogType.ResetPassAdmin, label: 'Reset mật khẩu tài khoản admin' },
  // { value: ELogType.CreateProvince, label: 'Tạo tỉnh thành' },
  // { value: ELogType.UpdateProvince, label: 'Sửa tỉnh thành' },
  // { value: ELogType.RemoveProvince, label: 'Xoá tỉnh thành' },
  // { value: ELogType.CreateDistrict, label: 'Tạo quận huyện' },
  // { value: ELogType.UpdateDistrict, label: 'Sửa quận huyện' },
  // { value: ELogType.RemoveDistrict, label: 'Xoá quận huyện' },
  // { value: ELogType.CreateNews, label: 'Tạo tin tức' },
  // { value: ELogType.UpdateNews, label: 'Sửa tin tức' },
  // { value: ELogType.RemoveNews, label: 'Xoá tin tức' },
  // { value: ELogType.ChangeStatusNews, label: 'Bật tắt tin tức' },
  { value: ELogType.CreateBanner, label: 'Tạo banner' },
  { value: ELogType.UpdateBanner, label: 'Sửa banner' },
  { value: ELogType.RemoveBanner, label: 'Xoá banner' },
  { value: ELogType.CreateFAQ, label: 'Tạo FAQ' },
  { value: ELogType.UpdateFAQ, label: 'Sửa FAQ' },
  { value: ELogType.RemoveFAQ, label: 'Xoá FAQ' },
  { value: ELogType.CreateRulesAndRegulations, label: 'Tạo nội quy và quy chế' },
  { value: ELogType.UpdateRulesAndRegulations, label: 'Sửa nội quy và quy chế' },
  { value: ELogType.ConfirmComplain, label: 'Xác nhận giải quyết khiếu nại' },
  { value: ELogType.RemoveVoucher, label: 'Xoá voucher' },
  { value: ELogType.CreateInsTruction, label: 'Tạo hướng dẫn sử dụng' },
  { value: ELogType.UpdateInsTruction, label: 'Sửa hướng dẫn sử dụng' },
  { value: ELogType.CreateOrder, label: 'Tạo đơn hàng' },
  { value: ELogType.UpdateOrder, label: 'Sửa đơn hàng' },
  { value: ELogType.ConfirmOrder, label: 'Duyệt đơn hàng' },
  { value: ELogType.CreateDelivery, label: 'Tạo đơn giao hàng' },
  { value: ELogType.CancelDelivery, label: 'Huỷ đơn giao hàng' },
  { value: ELogType.ExportWarehouse, label: 'Xuất kho' },
  { value: ELogType.CancelOrder, label: 'Huỷ đơn hàng' },
  { value: ELogType.ConfirmPayOrder, label: 'Thanh toán đơn hàng' },
  { value: ELogType.CreateReturnProduct, label: 'Tạo đơn trả hàng' },
  { value: ELogType.CancelReturnProduct, label: 'Huỷ đơn trả hàng' },
  { value: ELogType.ConfirmReturnProduct, label: 'Xác nhận nhập trả hàng' },
  { value: ELogType.UpdateCustomer, label: 'Cập nhật khách hàng' },
  { value: ELogType.CreateReceiptCustomer, label: 'Tạo phiếu thu khách hàng' },
  { value: ELogType.CreateRank, label: 'Tạo rank' },
  { value: ELogType.UpdateRank, label: 'Sửa rank' },
  { value: ELogType.DeleteRank, label: 'Xoá rank' },
  { value: ELogType.DeleteAdmin, label: 'Xoá admin' },
  { value: ELogType.CreateGroupAdmin, label: 'Tạo nhóm admin' },
  { value: ELogType.UpdateGroupAdmin, label: 'Sửa nhóm admin' },
  { value: ELogType.DeleteGroupAdmin, label: 'Xoá nhóm admin' },
  { value: ELogType.CreateProduct, label: 'Tạo sản phẩm' },
  { value: ELogType.UpdateProduct, label: 'Sửa sản phẩm' },
  { value: ELogType.DeleteProduct, label: 'Xoá sản phẩm' },
  { value: ELogType.ChangeStatusProduct, label: 'Thay đổi trạng thái sản phẩm' },
  { value: ELogType.CreateProductCategory, label: 'Tạo danh mục sản phẩm' },
  { value: ELogType.UpdateProductCategory, label: 'Sửa danh mục sản phẩm' },
  { value: ELogType.DeleteProductCategory, label: 'Xoá danh mục sản phẩm' },
  { value: ELogType.ChangeStatusProductCategory, label: 'Thay đổi trạng thái danh mục sản phẩm' },
  { value: ELogType.CreateProductGroup, label: 'Tạo nhóm sản phẩm' },
  { value: ELogType.UpdateProductGroup, label: 'Sửa nhóm sản phẩm' },
  { value: ELogType.DeleteProductGroup, label: 'Xoá nhóm sản phẩm' },
  { value: ELogType.ChangeStatusProductGroup, label: 'Thay đổi trạng thái nhóm sản phẩm' },
  { value: ELogType.CreateWarehouse, label: 'Tạo kho' },
  { value: ELogType.UpdateWarehouse, label: 'Sửa kho' },
  { value: ELogType.DeleteWarehouse, label: 'Xoá kho' },
  { value: ELogType.CreateSupplier, label: 'Tạo nhà cung cấp' },
  { value: ELogType.UpdateSupplier, label: 'Sửa nhà cung cấp' },
  { value: ELogType.DeleteSupplier, label: 'Xoá nhà cung cấp' },
  { value: ELogType.CreateReceiptSupplier, label: 'Tạo phiếu thu nhà cung cấp' },
  { value: ELogType.CreatePaySlipSupplier, label: 'Tạo phiếu chi nhà cung cấp' },
  { value: ELogType.CreatePurchaseOrder, label: 'Tạo đơn đặt hàng' },
  { value: ELogType.UpdatePurchaseOrder, label: 'Sửa đơn đặt hàng' },
  { value: ELogType.CancelPurchaseOrder, label: 'Huỷ đơn đặt hàng' },
  { value: ELogType.CreateImport, label: 'Tạo đơn nhập' },
  { value: ELogType.UpdateImport, label: 'Sửa đơn nhập' },
  { value: ELogType.CancelImport, label: 'Huỷ đơn nhập' },
  { value: ELogType.ConfirmImport, label: 'Xác nhận nhập đơn nhập' },
  { value: ELogType.ConfirmPayImport, label: 'Xác nhận thanh toán' },
  { value: ELogType.CreateReturnSupplier, label: 'Tạo đơn trả nhà cung cấp' },
  { value: ELogType.ConfirmPayReturnSupplier, label: 'Xác nhận thanh toán đơn trả nhà cung cấp' },
  { value: ELogType.CreateTransfer, label: 'Tạo điều chuyển' },
  { value: ELogType.UpdateTransfer, label: 'Sửa điều chuyển' },
  { value: ELogType.CancelTransfer, label: 'Huỷ điều chuyển' },
  { value: ELogType.FinishTransfer, label: 'Hoàn thành điều chuyển' },
  { value: ELogType.ConfirmTransfer, label: 'Xác nhận điều chuyển' },
  { value: ELogType.CreateSale, label: 'Tạo sale' },
  { value: ELogType.UpdateSale, label: 'Sửa sale' },
  { value: ELogType.ChangeStatusSale, label: 'Thay đổi trạng thái sale' },
  { value: ELogType.DeleteSale, label: 'Xoá sale' },
  { value: ELogType.CreateFlashSale, label: 'Tạo Flashsale' },
  { value: ELogType.UpdateFlashSale, label: 'Sửa Flashsale' },
  { value: ELogType.ChangeStatusFlashSale, label: 'Thay đổi trạng thái Flashsale' },
  { value: ELogType.DeleteFlashSale, label: 'Xoá Flashsale' },
  { value: ELogType.CreateGift, label: 'Tạo Gift' },
  { value: ELogType.UpdateGift, label: 'Sửa Gift' },
  { value: ELogType.ChangeStatusGift, label: 'Thay đổi trạng thái Gift' },
  { value: ELogType.DeleteGift, label: 'Xoá Gift' },
  { value: ELogType.CreateBuyALot, label: 'Tạo BuyALot' },
  { value: ELogType.UpdateBuyALot, label: 'Sửa BuyALot' },
  { value: ELogType.ChangeStatusBuyALot, label: 'Thay đổi trạng thái BuyALot' },
  { value: ELogType.DeleteBuyALot, label: 'Xoá BuyALot' },
  { value: ELogType.ChangeStatusVoucher, label: 'Thay đổi trạng thái voucher' },
  { value: ELogType.DeleteNotify, label: 'Xoá thông báo' },
  { value: ELogType.ChangeStatusBanner, label: 'Thay đổi trạng thái banner' },
  { value: ELogType.CreateSplashScreen, label: 'Tạo SplashScreen' },
  { value: ELogType.UpdateSplashScreen, label: 'Sửa SplashScreen' },
  { value: ELogType.ChangeStatusSplashScreen, label: 'Thay đổi trạng thái SplashScreen' },
  { value: ELogType.DeleteSplashScreen, label: 'Xoá SplashScreen' },
  { value: ELogType.DeleteInsTruction, label: 'Xoá hướng dẫn sử dụng' },
  { value: ELogType.ChangeStatusSystemConfig, label: 'Thay đổi trạng thái cấu hình' },
  { value: ELogType.DeleteSystemConfig, label: 'Xoá cấu hình' },
  { value: ELogType.CreatePaySlipType, label: 'Tạo loại phiếu chi' },
  { value: ELogType.UpdatePaySlipType, label: 'Tạo loại phiếu chi' },
  { value: ELogType.DeletePaySlipType, label: 'Xoá loại phiếu chi' },
  { value: ELogType.CreateReceiptType, label: 'Tạo loại phiếu thu' },
  { value: ELogType.UpdateReceiptType, label: 'Tạo loại phiếu thu' },
  { value: ELogType.DeleteReceiptType, label: 'Xoá loại phiếu thu' },
  { value: ELogType.CreatePaySlip, label: 'Tạo phiếu chi' },
  { value: ELogType.CreateReceipt, label: 'Tạo phiếu thu' },
  { value: ELogType.CancelPaySlip, label: 'Hủy phiếu chi' },
  { value: ELogType.CancelReceipt, label: 'Hủy phiếu thu' },
];
export enum ELinkType {
  LINK = 1, // Link liên kết
  PRODUCT = 2, // Sản phẩm
  PROMO = 3, // Ưu đãi
  PRODUCT_GROUP = 4, // Nhóm sản phẩm
  PRODUCT_CATEGORY = 5, // Danh mục sản phẩm
}

export enum EPromoBannerType {
  VOUCHER = 1, // voucher
  SALE = 2, // sale
  FLASH_SALE = 3, // flashSale
  GIFT = 4, // quà tặng
  BUY_A_LOT = 5, // mua nhiều giảm nhiều
  ALL = 6, // Tất cả
}

export interface IOptionLinkType {
  value: ELinkType;
  label: string;
}

export interface IPromoBannerType {
  value: EPromoBannerType;
  label: string;
}

export const LinkTypeOpts: IOptionLinkType[] = [
  { value: ELinkType.LINK, label: 'Link liên kết' },
  { value: ELinkType.PRODUCT, label: 'Sản phẩm' },
  { value: ELinkType.PROMO, label: 'Ưu đãi' },
  { value: ELinkType.PRODUCT_GROUP, label: 'Nhóm sản phẩm' },
  { value: ELinkType.PRODUCT_CATEGORY, label: 'Danh mục sản phẩm' },
];

export const PromoBannerTypeOpts: IPromoBannerType[] = [
  { value: EPromoBannerType.VOUCHER, label: 'Chương trình voucher' },
  { value: EPromoBannerType.SALE, label: 'Chương trình sale' },
  { value: EPromoBannerType.FLASH_SALE, label: 'Flash Sale' },
  { value: EPromoBannerType.GIFT, label: 'Tặng quà' },
  { value: EPromoBannerType.BUY_A_LOT, label: 'Mua nhiều giảm nhiều' },
];

export const PromoBannerTypeNotSaleOpts: IPromoBannerType[] = [
  { value: EPromoBannerType.VOUCHER, label: 'Chương trình voucher' },
  { value: EPromoBannerType.FLASH_SALE, label: 'Flash Sale' },
  { value: EPromoBannerType.GIFT, label: 'Tặng quà' },
  { value: EPromoBannerType.BUY_A_LOT, label: 'Mua nhiều giảm nhiều' },
];

//Phiếu thu chi Trong chi tiết KH
export enum ESlipType {
  RECEIPT = 1, // Phiếu thu
  PAY_SLIP = 2, // Phiếu chi
  EXPORT_WAREHOUSE = 3, // Đơn bán hàng
  RETURN_PRODUCT = 4, // Trả đơn bán hàng
  RECEIPT_AUTO = 5, // Phiếu thu tự động (Đơn hàng)
  PAY_SLIP_AUTO = 6, // Phiếu chi tự động (Đơn trả hafng)
}
export const supplierSlipType: ISelect[] = [
  { value: ESlipType.RECEIPT, label: 'Phiếu thu' },
  { value: ESlipType.PAY_SLIP, label: 'Phiếu chi' },
  { value: ESlipType.EXPORT_WAREHOUSE, label: 'Đơn bán hàng' },
  { value: ESlipType.RETURN_PRODUCT, label: 'Trả đơn bán hàng' },
  { value: ESlipType.RECEIPT_AUTO, label: 'Phiếu thu tự động' },
  { value: ESlipType.PAY_SLIP_AUTO, label: 'Phiếu chi tự động' },
];
export const getSlipTypeName = (type: number) => {
  return supplierSlipType.find((x) => x.value === type)?.label || '';
};
